import { render, staticRenderFns } from "./LocationsByClient.vue?vue&type=template&id=18b77db1&scoped=true&"
import script from "./LocationsByClient.vue?vue&type=script&lang=js&"
export * from "./LocationsByClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b77db1",
  null
  
)

export default component.exports